import logo from '../assets/logo-soilthm.png';

export default function Navbar() {
  return (

    <header className="header">
        <div className="logo-container">
        <img src={logo} alt="Soilthm logo" className="logo-image" />
        <span className="logo-text">Soilthm</span>
        </div>
        <a href="/contato">
            <button className="cta-button">Fale conosco</button>
        </a>
    </header>
  );
}